import { defineAction } from "@agent-native/core/action";
import { z } from "zod";

import { authorizeDispatchAdmin } from "../server/lib/app-roles.js";
import { deleteWorkspaceResource } from "../server/lib/workspace-resources-store.js";

export default defineAction({
  description:
    "Delete a workspace resource and revoke all its grants. When Dispatch approval policy is enabled, deleting an All-app resource queues an approval request before taking effect.",
  authorize: authorizeDispatchAdmin,
  schema: z.object({
    id: z.string().describe("Resource ID to delete"),
  }),
  run: async (args) => deleteWorkspaceResource(args.id),
});
